// extracted by mini-css-extract-plugin
export var header = "_wj-1";
export var maskBottom = "_wj-6";
export var maskMiddle = "_wj-7";
export var maskTop = "_wj-5";
export var root = "_wj-0";
export var scrollDownButton = "_wj-3";
export var scrollDownButtonHidden = "_wj-4";
export var viewport = "_wj-2";